import {curry} from 'ramda';
import {History} from 'history';
import {
    QCFilters,
    BaseFilters,
} from '../../QCWorkflow/QCFilters/QCFiltersType';

interface QueryArgs {
    setQCJobs: (params: QCFilters) => void;
    setQuery: (history: History, route: string, params: QCFilters) => void;
    history: History;
    route: string;
}

export const handleQcManagerList = curry((filters: QCFilters, queryArgs: QueryArgs, tablePaging: BaseFilters): void => {
    const {
        setQCJobs,
        setQuery,
        history,
        route,
    } = queryArgs;
    const params = {
        ...filters,
        ...tablePaging,
    };
    
    setQuery(history, route, params);
    setQCJobs(params);
});
